import { render, staticRenderFns } from "./AuthorDetail.vue?vue&type=template&id=467acfc4"
import script from "./AuthorDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AuthorDetail.vue?vue&type=style&index=0&id=467acfc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports